const aimStyles = {
  '@global': {
    ':root': {
      '&.aim-disabled': {
        '& *[tabindex]:focus': {
          outline: 'none',
        },
      },

      '&.aim-enabled': {
        '& *[tabindex]:focus': {
          outlineWidth: 2,
          outlineStyle: 'auto',
          outlineOffset: -1,
          outlineColor: 'var(--x-aim-outline-color)',
        },
      },
    },
  },
};

function withAimStyles() {
  function tabbed(e: KeyboardEvent) {
    if (typeof window === 'object') {
      if (e.keyCode === 9) {
        document.documentElement.classList.remove('aim-disabled');
        document.documentElement.classList.add('aim-enabled');

        window.removeEventListener('keydown', tabbed);
        window.addEventListener('mousedown', clicked);
      }
    }
  }

  function clicked() {
    if (typeof window === 'object') {
      document.documentElement.classList.remove('aim-enabled');
      document.documentElement.classList.add('aim-disabled');
      document.getElementById('aim-styles')?.remove();

      window.removeEventListener('mousedown', clicked);
      window.addEventListener('keydown', tabbed);
    }
  }

  if (typeof window === 'object') {
    document.documentElement.classList.add('aim-disabled');
    window.addEventListener('keydown', tabbed);
  }
}

export { withAimStyles };
export default aimStyles;
